module.exports = __webpack_public_path__ + "img/Bergungsgruppe_ASH.5a117f57.svg";